module.exports = __webpack_public_path__ + "img/shequn_bg@2x.c32efaa2.png";